{
  "enum": {
    "O5DanteV1DeadMessageStatus": {
      "CREATED": "Created",
      "REJECTED": "Rejected",
      "REPLAYED": "Replayed",
      "UNSPECIFIED": "Unspecified",
      "UPDATED": "Updated"
    }
  },
  "filterEnum": {
    "O5DanteV1DeadMessageQueryServiceDeadMessageListFilterableFields": {
      "data": {
        "notification": {
          "handlerApp": "Handler App",
          "handlerEnv": "Handler Env"
        }
      },
      "messageId": "Message",
      "status": "Status"
    }
  },
  "oneOf": {
    "O5DanteV1DeadMessageEventType": {
      "notified": "Notified",
      "rejected": "Rejected",
      "replayed": "Replayed",
      "updated": "Updated"
    }
  },
  "searchEnum": {
    "O5DanteV1DeadMessageQueryServiceDeadMessageListSearchableFields": {
      "data": {
        "notification": {
          "problem": {
            "unhandledError": {
              "error": "Error"
            }
          }
        }
      }
    }
  },
  "sortEnum": {
    "O5DanteV1DeadMessageQueryServiceDeadMessageListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}